import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	description: {
		id: 'servicedesk-incident-management-settings.common.upgrade-plan-content.description',
		defaultMessage: 'Upgrade to a Premium or Enterprise plan to use this feature.',
		description:
			'Message of warning popper to forward user to upgrade their plan to premium or enterprise',
	},
	ctaLink: {
		id: 'servicedesk-incident-management-settings.common.upgrade-plan-content.cta-link',
		defaultMessage: 'Upgrade now',
		description: 'CTA link that redirects user to upgrade page',
	},
});
